'use client';

import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

import BreadCrump from '@/components/BreadCrump';
import MasonrySkeleton from '@/components/MasonrySkeleton';
import BreadcrumbWrap from '@/components/BreadcrumbWrap';
import { HeaderSkeleton, GridSection } from '@/components/SkeletonLayout';
import { BREADCRUMB_BASE_SEGMENT, BREADCRUMB_SKELETON_SEGMENT } from '@/constants/breadcrumb';

const Loading = () => (
  <>
    <BreadcrumbWrap>
      <BreadCrump segments={[BREADCRUMB_BASE_SEGMENT, BREADCRUMB_SKELETON_SEGMENT]} />
    </BreadcrumbWrap>
    <HeaderSkeleton>
      <Skeleton width={208} height={40} borderRadius={CornerRadius.r4} />
      <Skeleton width="100%" height={60} borderRadius={CornerRadius.r4} />
    </HeaderSkeleton>
    <GridSection>
      <MasonrySkeleton itemCount={30} />
    </GridSection>
  </>
);

export default Loading;
